import { render, staticRenderFns } from "./FComment.vue?vue&type=template&id=6e918e02&"
import script from "./FComment.vue?vue&type=script&lang=ts&"
export * from "./FComment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports